// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-editable:hover {
  color: rgb(75, 75, 255) !important;
}
.txt-editable:hover::before {
  -webkit-font-smoothing: antialiased !important;
  font-family: "Font Awesome 5 Free" !important;
  font-weight: 900 !important;
  content: " \\f044  " !important;
}

.fases-titulo {
  padding-left: 0;
}
.fases-titulo div.fase {
  float: left;
}
.fases-titulo div.fase div.contenido {
  color: #4a4a4a;
  width: 250px;
  display: block;
  background: #f1f1f1;
  text-decoration: none;
  position: relative;
  height: 60px;
  line-height: 60px;
  padding: 0 10px 0 5px;
  text-align: left;
  margin-right: 22px;
}
.fases-titulo div.fase:first-child div.contenido {
  padding-left: 15px;
  border-radius: 4px 0 0 4px;
}
.fases-titulo div.fase:first-child div.contenido:before {
  border: none;
}
.fases-titulo div.fase div.contenido:before, .fases-titulo div.fase div.contenido:after {
  content: "";
  position: absolute;
  top: 0;
  border: 0 solid #f1f1f1;
  border-width: 30px 10px;
  width: 0;
  height: 0;
}
.fases-titulo div.fase div.contenido:before {
  left: -20px;
  border-left-color: transparent;
}
.fases-titulo div.fase div.contenido:after {
  left: 100%;
  border-color: transparent;
  border-left-color: #f1f1f1;
}
.fases-titulo div.fase div.contenido:hover {
  background-color: #e7e7e7;
}
.fases-titulo div.fase div.contenido:hover:before {
  border-color: #e7e7e7;
  border-left-color: transparent;
}
.fases-titulo div.fase div.contenido:hover:after {
  border-left-color: #e7e7e7;
}

.fase-opciones {
  cursor: pointer;
  border-radius: 3px;
  width: 30px;
  height: 30px;
  z-index: 1000;
}

.titulo {
  color: #4a4a4a;
  position: absolute;
  width: 90%;
  font-size: 1rem;
  top: -15px;
  font-weight: 600;
}

.sub-titulo {
  color: #4a4a4a;
  position: absolute;
  width: 90%;
  font-size: 0.75rem;
  top: 15px;
  color: gray;
}
.sub-titulo .fa {
  color: #555555;
}

.fondo {
  background-color: red;
  overflow-y: visible;
  overflow-x: visible;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/crm/components/pipeline/pipeline.component.scss"],"names":[],"mappings":"AAWC;EACC,kCAAA;AAVF;AAWE;EACC,8CAAA;EACA,6CAAA;EACA,2BAAA;EACA,8BAAA;AATH;;AAaA;EACC,eAAA;AAVD;AAWC;EACC,WAAA;AATF;AAWE;EACC,cAtBM;EAuBN,YAAA;EACA,cAAA;EACA,mBA3BY;EA4BZ,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AATH;AAYG;EACC,kBAAA;EACA,0BAAA;AAVJ;AAWI;EACC,YAAA;AATL;AAwBG;EAEC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;AAvBJ;AAyBG;EACC,WAAA;EACA,8BAAA;AAvBJ;AAyBG;EACC,UAAA;EACA,yBAAA;EACA,0BAzEW;AAkDf;AAyBG;EACC,yBA3EW;AAoDf;AAyBI;EACC,qBA9EU;EA+EV,8BAAA;AAvBL;AAyBI;EACC,0BAlFU;AA2Df;;AA8BA;EACC,eAAA;EAEA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AA5BD;;AA+BA;EACC,cAlGQ;EAmGR,kBAAA;EACA,UAAA;EACA,eAnGa;EAoGb,UAAA;EACA,gBAAA;AA5BD;;AA8BA;EACC,cA1GQ;EA2GR,kBAAA;EACA,UAAA;EACA,kBA1GgB;EA2GhB,SAAA;EACA,WAAA;AA3BD;AA4BC;EACC,cAhHY;AAsFd;;AA6BA;EACC,qBAAA;EACA,mBAAA;EACA,mBAAA;AA1BD;;AA6BA;EACC,sBAAA;EACA,kBAAA;EACA,qHAAA;AA1BD;;AA6BA;EACC,sDAAA;AA1BD","sourcesContent":["// @import \"compass/css3\";\n\n// >>>>> https://codepen.io/firatcftc/pen/sHlnK\n$fondo-normal: #f1f1f1;\n$fondo-activo: #e7e7e7;\n$letras: #4a4a4a;\n$color-icono: #555555;\n$titulo-size: 1rem;\n$subtitulo-size: 0.75rem;\n\n.txt-editable {\n\t&:hover {\n\t\tcolor: rgb(75, 75, 255) !important;\n\t\t&::before {\n\t\t\t-webkit-font-smoothing: antialiased !important;\n\t\t\tfont-family: \"Font Awesome 5 Free\" !important;\n\t\t\tfont-weight: 900 !important;\n\t\t\tcontent: \" \\f044 \\ \" !important;\n\t\t}\n\t}\n}\n.fases-titulo {\n\tpadding-left: 0;\n\tdiv.fase {\n\t\tfloat: left;\n\n\t\tdiv.contenido {\n\t\t\tcolor: $letras;\n\t\t\twidth: 250px;\n\t\t\tdisplay: block;\n\t\t\tbackground: $fondo-normal;\n\t\t\ttext-decoration: none;\n\t\t\tposition: relative;\n\t\t\theight: 60px;\n\t\t\tline-height: 60px;\n\t\t\tpadding: 0 10px 0 5px;\n\t\t\ttext-align: left;\n\t\t\tmargin-right: 22px;\n\t\t}\n\t\t&:first-child {\n\t\t\tdiv.contenido {\n\t\t\t\tpadding-left: 15px;\n\t\t\t\tborder-radius: 4px 0 0 4px;\n\t\t\t\t&:before {\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// &:last-child {\n\t\t// \tdiv.contenido {\n\t\t// \t\tpadding-right: 15px;\n\t\t// \t\tborder-radius: 0 4px 4px 0;\n\t\t// \t\t&:after {\n\t\t// \t\t\tborder: none;\n\t\t// \t\t}\n\t\t// \t}\n\t\t// }\n\n\t\tdiv.contenido {\n\t\t\t&:before,\n\t\t\t&:after {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tborder: 0 solid $fondo-normal;\n\t\t\t\tborder-width: 30px 10px;\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\t\t\t}\n\t\t\t&:before {\n\t\t\t\tleft: -20px;\n\t\t\t\tborder-left-color: transparent;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tleft: 100%;\n\t\t\t\tborder-color: transparent;\n\t\t\t\tborder-left-color: $fondo-normal;\n\t\t\t}\n\t\t\t&:hover {\n\t\t\t\tbackground-color: $fondo-activo;\n\n\t\t\t\t&:before {\n\t\t\t\t\tborder-color: $fondo-activo;\n\t\t\t\t\tborder-left-color: transparent;\n\t\t\t\t}\n\t\t\t\t&:after {\n\t\t\t\t\tborder-left-color: $fondo-activo;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.fase-opciones {\n\tcursor: pointer;\n\n\tborder-radius: 3px;\n\twidth: 30px;\n\theight: 30px;\n\tz-index: 1000;\n}\n\n.titulo {\n\tcolor: $letras;\n\tposition: absolute;\n\twidth: 90%;\n\tfont-size: $titulo-size;\n\ttop: -15px;\n\tfont-weight: 600;\n}\n.sub-titulo {\n\tcolor: $letras;\n\tposition: absolute;\n\twidth: 90%;\n\tfont-size: $subtitulo-size;\n\ttop: 15px;\n\tcolor: gray;\n\t.fa {\n\t\tcolor: $color-icono;\n\t}\n}\n.fondo {\n\tbackground-color: red;\n\toverflow-y: visible;\n\toverflow-x: visible;\n}\n\n.cdk-drag-preview {\n\tbox-sizing: border-box;\n\tborder-radius: 4px;\n\tbox-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-animating {\n\ttransition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
